import { getConfig } from '@micro-apps/env';

const { ENABLE_ANALYTICS_LOGGING } = getConfig(process.env);

function log(...args) {
	if (ENABLE_ANALYTICS_LOGGING) {
		console.log.apply(console, ['ANALYTICS', ...args]);
	}
}

export const trackPage = data => {
	window.utag_data = window.utag_data || {};
	log('trackPage', { data });
	window?.FS?.Tealium?.trackPage(data);
};

export const trackLink = (eventName, data, uid) => {
	window.utag_data = window.utag_data || {};
	log('trackLink', { eventName, data, uid });
	window?.FS?.Tealium?.trackLink(eventName, data, uid);
};

export const trackInteraction = (type, name, detail, $el, extraData) => {
	window.utag_data = window.utag_data || {};
	log('trackInteraction', { type, name, detail, $el, extraData });
	window?.FS?.Tealium?.trackInteraction(type, name, detail, $el, extraData);
};
